// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FolderOutlinedSvg from "@fishx/icons-svg/es/asn/FolderOutlined";
import FishxIcon from '../components/FishxIcon';

var FolderOutlined = function FolderOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FolderOutlinedSvg
  }));
};

FolderOutlined.displayName = 'FolderOutlined';
export default React.forwardRef(FolderOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FolderOutlined.js
// module id = 2805
// module chunks = 0